import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
import SearchIcon from "components/common/elsevier/Icons/SearchIcon";
import { ELSButton } from "components/common/elsevier/Button/Button";
import styles from "./Submit.module.scss";
function Submit(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ELSButton, _extends({
    className: "es-button__primary ".concat(className),
    type: "submit"
  }, props, {
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, {
      className: styles.submit__icon
    })
  }), /*#__PURE__*/React.createElement("span", {
    "data-cy": "submit-search-button-text"
  }, "Search"));
}
Submit.defaultProps = {
  disabled: false,
  onClick: function onClick() {}
};
export default Submit;